export function getContext() {
  if (typeof window === 'undefined') return {}
  return window.microsDatas || {}
}
